const PaymentTypeEnum = {
  NICEPAY: 1,
  LINEPAY: 2,
  SOFTBANKPAY: 3,
  KOVANPAY: 4,
  HECTO: 6,
};

export default PaymentTypeEnum;
